import { findEmployeeById, formatEmployeeLabel } from "./employeeUtils";
import { formatPayPeriodLabel } from "./PayPeriodSelect";

/** Prefer API-provided employee_name; fall back to client employee list. */
export function resolveEmployeeDisplay(row, employees) {
  if (!row) return "—";
  if (row.employee_name) {
    const code = row.employee_code ? ` (${row.employee_code})` : "";
    return `${row.employee_name}${code}`;
  }
  return (
    formatEmployeeLabel(findEmployeeById(employees, row.employee_id)) ||
    row.employee_id ||
    "—"
  );
}

export function resolvePayPeriodDisplay(row) {
  if (!row) return "—";
  return row.period_label || formatPayPeriodLabel(row) || "Pay period";
}

export function resolvePayrollRunDisplay(row, period) {
  if (!row) return "—";
  if (row.payroll_run_label) return row.payroll_run_label;
  const periodLabel = resolvePayPeriodDisplay(period || row);
  return periodLabel !== "—" ? `${periodLabel} · Payroll run` : "Payroll run";
}

export function resolveOrganisationDisplay(row) {
  if (!row) return "—";
  return row.organisation_name || row.name || "Organisation";
}

export function resolveDepartmentDisplay(row) {
  if (!row) return "—";
  return row.department_name || row.department?.name || "—";
}

/** Execution trace employee_index entry or API row with employee_name. */
export function resolveTraceEmployeeDisplay(employeeId, trace, employees) {
  const ref = trace?.employee_index?.[String(employeeId)];
  if (ref?.employee_name) {
    const code = ref.employee_code ? ` (${ref.employee_code})` : "";
    return `${ref.employee_name}${code}`;
  }
  return (
    formatEmployeeLabel(findEmployeeById(employees, employeeId)) ||
    employeeId ||
    "—"
  );
}

export function resolveTemplateDisplay(templateId, trace) {
  if (!templateId) return "—";
  return trace?.template_labels?.[String(templateId)] || `Template ${String(templateId).slice(0, 8)}…`;
}
